import ProfileModel from './profile-model';
import shivProfile from './profile-pictures/shiv.jpeg';

const shiv = new ProfileModel({
    username: 'shiv',
    password: 'admin',
    profilePicture: shivProfile,
    firstName: 'Shivum',
    lastName: 'A.',
    files: [
        "//v2.grommet.io/assets/Wilderpeople_Ricky.jpg"
    ],
    key: 3,
})

export default shiv;